/* Treatment booking card: keeps the primary "Book" button's destination
   (and, where the option has one, the therapist-facing note it implies via
   its label) in sync with whichever price option the visitor has selected.

   One instance renders per treatment page, but the definition is guarded
   the same way as this theme's other custom elements (treatment-hub.js,
   product-form.js, etc.) so a repeated element registration never throws. */

if (!customElements.get('treatment-booking-card')) {
  class TreatmentBookingCard extends HTMLElement {
    connectedCallback() {
      this.bookButton = this.querySelector('[data-treatment-book-button]');
      this.bookButtonName = this.querySelector('[data-treatment-book-name]');
      this.inputs = Array.from(this.querySelectorAll('.treatment-bookcard__option-input'));
      if (!this.bookButton || !this.inputs.length) return;

      this.inputs.forEach((input) => {
        input.addEventListener('change', () => this.applySelection(input));
      });

      const checked = this.inputs.find((input) => input.checked) || this.inputs[0];
      this.applySelection(checked);
    }

    applySelection(input) {
      if (!input || !input.value) return;
      this.bookButton.setAttribute('href', input.value);
      if (this.bookButtonName && input.dataset.optionName) {
        this.bookButtonName.textContent = ` \u2014 ${input.dataset.optionName}`;
      }
    }
  }

  customElements.define('treatment-booking-card', TreatmentBookingCard);
}
